import * as ThemeColor from './Color';
export var Size;
(function (Size) {
    Size[Size["XXSmall"] = 8] = "XXSmall";
    Size[Size["XSmall"] = 16] = "XSmall";
    Size[Size["Small"] = 24] = "Small";
    Size[Size["Medium"] = 28] = "Medium";
    Size[Size["Large"] = 32] = "Large";
    Size[Size["XLarge"] = 48] = "XLarge";
    Size[Size["XXLarge"] = 64] = "XXLarge";
})(Size || (Size = {}));
export var Radius;
(function (Radius) {
    Radius[Radius["Small"] = 4] = "Small";
    Radius[Radius["Medium"] = 8] = "Medium";
})(Radius || (Radius = {}));
export var Spacing;
(function (Spacing) {
    Spacing[Spacing["Medium"] = 12] = "Medium";
})(Spacing || (Spacing = {}));
export const Variant = {
    Outline: {
        Color: {
            Background: ThemeColor.Neutrals.Paper,
            Border: ThemeColor.Brand.Primary,
            Content: ThemeColor.Brand.Primary,
        },
        Hover: {
            Background: ThemeColor.Neutrals.Light,
            Content: ThemeColor.Brand.Primary,
        },
    },
    Secondary: {
        Color: {
            Background: ThemeColor.Neutrals.Light,
            Content: ThemeColor.Neutrals.Dark,
        },
        Hover: {
            Background: ThemeColor.Brand.Primary,
            Content: ThemeColor.Brand.Primary,
        },
    },
};
//# sourceMappingURL=Button.js.map